module.exports = __webpack_public_path__ + "static/media/godwins.4b376dfc.jpg";